const LOADING_SCREEN_PREFIX = "fpl";

export const LOADING_SCREEN_TEST_IDS = {
    CONTAINER: `${LOADING_SCREEN_PREFIX}_container`,
    CIRCLE_LOADER: `${LOADING_SCREEN_PREFIX}_circle_loader`,
};
